import { AVATAR_SRC } from "@/components/clinic/SelvixAvatar";
import { Compass, Video, Home, FileSignature, FolderLock, MessageCircle, X } from "lucide-react";

const OPTIONS = [
  { key: "esplora", label: "Esplora la clinica", icon: Compass },
  { key: "telemedicina", label: "Video consulto", icon: Video },
  { key: "domiciliare", label: "Assistenza domiciliare", icon: Home },
  { key: "richieste", label: "Richieste mediche", icon: FileSignature },
  { key: "documenti", label: "Documenti sanitari", icon: FolderLock },
  { key: "chat", label: "Parla con Doctor Selvix", icon: MessageCircle },
];

export function WelcomeDialog({ message, onPick, onClose }) {
  return (
    <div data-testid="selvix-welcome-dialog" className="pointer-events-auto absolute inset-x-3 bottom-3 z-30 sm:inset-x-auto sm:bottom-8 sm:left-8 sm:w-[min(640px,calc(100vw-4rem))]">
      <div className="glass relative flex gap-4 overflow-hidden rounded-3xl p-4 sm:p-6 rise">
        <button data-testid="selvix-welcome-close" onClick={onClose} className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full text-slate-500 transition-colors hover:bg-slate-100" aria-label="Chiudi">
          <X className="h-4 w-4" />
        </button>
        <img src={AVATAR_SRC} alt="Doctor Selvix" className="hidden h-44 w-auto shrink-0 object-contain sm:block" />
        <div className="min-w-0">
          <p className="pr-8 text-[10px] font-bold uppercase tracking-[0.25em] text-cyan-700">Doctor Selvix · Direttore Generale virtuale · Assistente AI</p>
          <p data-testid="selvix-welcome-message" className="mt-2 pr-6 text-sm leading-relaxed text-slate-700 sm:text-[15px]">{message}</p>
          <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3">
            {OPTIONS.map((o, i) => (
              <button
                key={o.key}
                data-testid={`welcome-option-${o.key}`}
                onClick={() => onPick(o.key)}
                className={`rise flex items-center gap-2 rounded-xl border px-3 py-2 text-left text-xs font-semibold transition-colors ${o.key === "chat" ? "col-span-2 border-sky-600 bg-sky-600 text-white hover:bg-sky-700 sm:col-span-1" : "border-slate-200 bg-white text-slate-700 hover:border-cyan-400 hover:text-sky-700"}`}
                style={{ animationDelay: `${i * 40}ms` }}
              >
                <o.icon className="h-4 w-4 shrink-0" />
                {o.label}
              </button>
            ))}
          </div>
          <p className="mt-3 text-[11px] text-slate-500">Doctor Selvix è un assistente AI, non un medico. Non fornisce diagnosi né prescrizioni. Emergenze: <b className="text-red-600">112</b>.</p>
        </div>
      </div>
    </div>
  );
}
